export default __webpack_public_path__ + "media/male.24420522.svg";